import {
  PinIcon,
  CalendarClockIcon,
  SendHorizontalIcon,
} from '@buffer-mono/popcorn'
import type { IconProps } from '@buffer-mono/popcorn'

import type { ScheduleOption } from './types'

export const SCHEDULE_OPTIONS: Record<
  ScheduleOption,
  {
    icon: React.FC<IconProps>
    label: string
    description?: string
    withSeparator?: boolean
  }
> = {
  Queue: {
    icon: CalendarClockIcon,
    label: 'Next Available',
    description: 'Use the next available posting slot in your queue.',
  },
  Prioritize: {
    icon: CalendarClockIcon,
    label: 'Prioritize',
    description: 'Bump your post to the top of the queue.',
  },
  Now: {
    icon: SendHorizontalIcon,
    label: 'Now',
    description: 'Publish your post right away.',
  },
  FixedTime: {
    icon: PinIcon,
    label: 'Set Date and Time',
    description: 'Choose a specific time to post, or use our recommendation.',
  },
}

export const PrioritizeOption = SCHEDULE_OPTIONS.Prioritize

export const SCHEDULE_OPTIONS_FOR_APPROVAL_REQUIRED: ScheduleOption[] = [
  'Queue',
  'FixedTime',
]

export const DEFAULT_SCHEDULE_OPTIONS: ScheduleOption[] = [
  'Queue',
  'Prioritize',
  'Now',
  'FixedTime',
]
